var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},_vm._l((_vm.datalist),function(item,index){return _c('div',{key:index,staticClass:"van-row"},[_c('div',{staticClass:"span32"},[_c('span',[_c('van-tag',{attrs:{"color":item.status === 0
              ? 'rgba(255, 78, 52, .2)'
              : item.status === 1
              ? 'rgba(34, 203, 140, .2)'
              : 'rgba(239, 156, 44, .2)',"text-color":item.status === 0
              ? 'rgba(255, 78, 52, 1)'
              : item.status === 1
              ? 'rgba(34, 203, 140, 1)'
              : 'rgba(239, 156, 44, 1)',"type":"primary"}},[_vm._v(_vm._s(item.branchName))]),_vm._v(" "+_vm._s(item.title))],1),_c('span',[_c('img',{attrs:{"src":require('../assets/home/time.png'),"alt":""}}),_vm._v(" "+_vm._s(item.createTime))])]),_c('div',{staticClass:"span33",on:{"click":function($event){return _vm.toWarnDetail('/warningDetail', index)}}},[_c('span',{class:item.status === 1
            ? 'active'
            : item.status === 2
            ? 'active1'
            : 'active2'},[_vm._v(_vm._s(+item.status === 1 ? "已处理" : item.status === 2 ? "待处理" : "未处理"))]),_c('van-icon',{attrs:{"name":"arrow"}})],1)])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }